export enum CARD_STATUSES {
	NOT_ACTIVATED = 1,
	ACTIVATED = 2,
	BLOCKED_BY_USER = 3,
	BLOCKED_BY_COMPANY = 4,
	SECURITY_BLOCK = 5,
	CANCELLED = 6,
	EXPIRED = 7
}
